import React, { Component } from 'react'

class MailInfoPicker extends Component {

    render(){
        const {mailInfoData, onChange, disabled} = this.props
        return(
            <div className="mail-info-block">
                <div>
                    <input
                        type="checkbox"
                        id="mailInfo"
                        name="mailInfo"
                        value="mailInfo"
                        onChange={onChange}
                        checked={mailInfoData}
                        disabled={disabled}
                    />
                        <label htmlFor="mailInfo">
                            Acepto recibir información al correo. Ver&nbsp;
                        </label>
                </div>
                <div className="terms-and-conditions-link" onClick={this.displayTermsAndConditions}>
                    terminos y condiciones
                </div>
            </div>
        )
    }
}

export default MailInfoPicker
